/* Generic video pop-up: any link with [data-video-popup] opens its YouTube / Vimeo / mp4 URL in a lightbox. */
(function () {
  if (window.__videoPopupInit) return;
  window.__videoPopupInit = true;

  var css =
    '.vp-modal{position:fixed;inset:0;z-index:2000;display:flex;align-items:center;justify-content:center;padding:24px}' +
    '.vp-modal[hidden]{display:none}' +
    '.vp-modal__backdrop{position:absolute;inset:0;background:rgba(20,0,0,.82)}' +
    '.vp-modal__dialog{position:relative;width:min(1100px,100%)}' +
    '.vp-modal__frame{position:relative;width:100%;aspect-ratio:16/9;background:#000}' +
    '.vp-modal__frame iframe,.vp-modal__frame video{position:absolute;inset:0;width:100%;height:100%;border:0}' +
    '.vp-modal__close{position:absolute;top:-44px;right:0;width:40px;height:40px;padding:0;border:0;background:none;color:#fff;font-size:34px;line-height:1;cursor:pointer}' +
    'html.vp-open{overflow:hidden}';

  function embedFor(url) {
    var u;
    try { u = new URL(url, window.location.href); } catch (e) { return null; }
    var host = u.hostname.replace(/^www\./, '');
    var id = null;
    if (host === 'youtu.be') id = u.pathname.slice(1);
    else if (host.indexOf('youtube.com') > -1) {
      if (u.pathname === '/watch') id = u.searchParams.get('v');
      else if (/^\/(embed|shorts|live)\//.test(u.pathname)) id = u.pathname.split('/')[2];
    }
    if (id) return { type: 'iframe', src: 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1' };
    if (host.indexOf('vimeo.com') > -1) {
      var m = u.pathname.match(/(\d+)/);
      if (m) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' };
    }
    if (/\.(mp4|webm|mov)(\?|$)/i.test(u.pathname + u.search)) return { type: 'video', src: u.href };
    return null;
  }

  var modal, frame, lastFocus;

  function build() {
    if (modal) return;
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    modal = document.createElement('div');
    modal.className = 'vp-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Video');
    modal.innerHTML =
      '<div class="vp-modal__backdrop" data-vp-close></div>' +
      '<div class="vp-modal__dialog"><button type="button" class="vp-modal__close" data-vp-close aria-label="Close video">&times;</button>' +
      '<div class="vp-modal__frame"></div></div>';
    document.body.appendChild(modal);
    frame = modal.querySelector('.vp-modal__frame');
    modal.querySelectorAll('[data-vp-close]').forEach(function (el) { el.addEventListener('click', close); });
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    frame.innerHTML = '';
    document.documentElement.classList.remove('vp-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus) lastFocus.focus();
  }

  // capture phase on document so this runs before the theme's own YouTube link handler
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-video-popup]');
    if (!opener) return;
    var embed = embedFor(opener.getAttribute('href'));
    if (!embed) return; // not embeddable: let the link behave normally
    e.preventDefault();
    e.stopPropagation();
    build();
    lastFocus = opener;
    var node;
    if (embed.type === 'iframe') {
      node = document.createElement('iframe');
      node.src = embed.src;
      node.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      node.allowFullscreen = true;
      node.title = 'Video';
    } else {
      node = document.createElement('video');
      node.src = embed.src;
      node.controls = true;
      node.autoplay = true;
      node.playsInline = true;
    }
    frame.innerHTML = '';
    frame.appendChild(node);
    modal.hidden = false;
    document.documentElement.classList.add('vp-open');
    document.addEventListener('keydown', onKey);
    modal.querySelector('.vp-modal__close').focus();
  }, true);
})();
